module.exports = __webpack_public_path__ + "img/DEU.f7e1f572.svg";